<template>
    <div>

        <div class="my-6 flex items-center">
            <span class="inline-block mr-6">Select a date: </span>
            <select class="form-input my-0" name="month" id="" v-model="date.month">
                <option v-for="i in 12" :value="i - 1">{{ showMonthName(i - 1) }}</option>
            </select>
            <span class="inline-block mx-2">/</span>
            <select class="form-input my-0" name="year" id="" v-model="date.year">
                <option v-for="i in yearSelect" :value="i">{{i}}</option>
            </select>

            <button @click="selectDate(-1)" class="btn btn-info ml-6" style="min-width: 2.8rem;">-</button>
            <button @click="selectDate(1)" class="btn btn-info ml-6" style="min-width: 2.8rem;">+</button>

        </div>


        <div v-if="init && !loading">
            
            <div v-if="this.filteredSubordinates">
                <table class="table w-8/12">
                    <thead>
                        <tr>
                            <th class="w-4/12">Subordinate</th>
                            <th class="w-1/12">Preview</th>
                            <th class="w-1/12">
                                <span class="tooltip">
                                    <span>Rvd</span>
                                    <span class="tooltip-text capitalize" style="width: 100px; left: 0px;">Remaining vacation days</span>
                                </span>
                            </th>
                            <th class="w-2/12">
                                <CellType>
                                    <template v-slot:type>Published</template>
                                    <template v-slot:by>by employee</template>
                                </CellType>                            
                            </th>
                            <th class="w-2/12">
                                <CellType>
                                    <template v-slot:type>Confirmed</template>
                                    <template v-slot:by>by team leader</template>
                                </CellType>
                            </th>
                            <th class="w-2/12">
                            <CellType>
                                    <template v-slot:type>Checked</template>
                                    <template v-slot:by>by accounter</template>
                                </CellType>
                            </th>
                            <th class="w-1/12">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in filteredSubordinates" :key="user.uid">
                            <td>
                                <div class="flex items-center">
                                    <span>
                                        <Zondicon icon="user" class="w-4 mr-4 fill-current" />
                                    </span>
                                    <span>{{ user.name }}</span>
                                </div>
                            </td>
    
                             <td>
                                <div v-if="getMarktime(user.uid)" class="text-center">
                                    <router-link :to="{name: 'preview', params: {id: getMarktime(user.uid).id}}" target="_blank" class="text-sm mr-2 btn btn-small btn-info">
                                        Preview
                                    </router-link>
                                </div>
                            </td>

                            <td>
                                <div class="text-xs text-center">
                                	{{ getRemainingVacationDays(user.uid) }}
                                </div>
                            </td>
    
                            <td>
                                <div v-if="getMarktime(user.uid)">
                                    <div v-if="getMarktime(user.uid).published">
                                        <div class="flex items-center leading-tight">
                                            <div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                                            <div>published</div>
                                        </div>
                                        <div class="leading-tight">
                                            <span class="text-gray-500 italic text-xs">{{ getDate(getMarktime(user.uid).publishedDate) }}</span>
                                        </div>
                                    </div>
                                    <div v-else class="flex items-center">
                                        <div class="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                                        <div>not yet</div>
                                    </div>
                                </div>
                            </td>
    
                            <td>
                                <div v-if="getMarktime(user.uid)">
                                    <div v-if="getMarktime(user.uid).published">
                                        <div v-if="getMarktime(user.uid).confirmed">
                                            <div class="flex items-center leading-tight">
                                                <div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                                                <div>confirmed</div>
                                            </div>
                                            <div class="leading-tight">
                                                <span class="text-gray-500 italic text-xs">{{ getDate(getMarktime(user.uid).confirmedDate) }}</span>
                                            </div>
                                        </div>
                                        <button v-else @click="showConfirmModal(getMarktime(user.uid).id)" class="btn btn-small btn-secondary mr-2">
                                            Confirm
                                        </button>
                                    </div>
                                </div>
                            </td>
    
                            <td>
                                <div v-if="getMarktime(user.uid)">
                                    <div v-if="getMarktime(user.uid).published">
                                        <div v-if="getMarktime(user.uid).checked">
                                            <div class="flex items-center leading-tight">
                                                <div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                                                <div>checked</div>
                                            </div>
                                            <div class="leading-tight">
                                                <span class="text-gray-500 italic text-xs">{{ getDate(getMarktime(user.uid).checkedDate) }}</span>
                                            </div>
                                        </div>
                                        <div v-else class="flex items-center">
                                            <div class="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                                            <div>not yet</div>
                                        </div>
                                    </div>
                                </div>
                            </td>
    
                            <td>
                                <div v-if="getMarktime(user.uid)" class="flex items-center">
                                    <div v-if="!getMarktime(user.uid).checked && getMarktime(user.uid).published" class="text-gray-600 cursor-pointer mr-4 tooltip" @click="openUnpublishModal(getMarktime(user.uid).id)">
                                        <Zondicon icon="arrow-outline-up" class="w-4 fill-current" />
                                        <span class="tooltip-text">Unpublish</span>
                                    </div>
                                    <div v-if="!getMarktime(user.uid).checked && getMarktime(user.uid).confirmed" class="text-gray-600 cursor-pointer mr-4 tooltip" @click="openUnconfirmModal(getMarktime(user.uid).id)">
                                        <Zondicon icon="browser-window-open" class="w-4 fill-current" />
                                        <span class="tooltip-text">Unconfirm</span>
                                    </div>
                                </div>
                            </td>
    
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>
                You do not have any subordinates yet!
            </div>

        </div>

        <div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>

        <SimpleModal v-if="showModal" @action="confirm" @close="showModal = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Confirm this marktime</template>
            <template v-slot:body>Are you sure you want to confirm this marktime?</template>
            <template v-slot:button>Confirm</template>
        </SimpleModal>

        <SimpleModal v-if="unconfirmModal" @action="unconfirm" @close="unconfirmModal = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Unconfirm this marktime</template>
            <template v-slot:body>Are you sure you want to unconfirm this marktime?</template>
            <template v-slot:button>Unconfirm</template>
        </SimpleModal>

        <SimpleModal v-if="unpublishModal" @action="unpublish" @close="unpublishModal = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Unpublish this marktime</template>
            <template v-slot:body>Are you sure you want to unpublish this marktime?</template>
            <template v-slot:button>Unpublish</template>
        </SimpleModal>

    </div>
</template>

<script>
import moment from 'moment';
import { mapState } from "vuex";
import { db } from "@/firebase";
import Zondicon from 'vue-zondicons'
import mixinDashboard from '../../mixins/dashboard'

import SimpleModal from '@/components/SimpleModal.vue'
import CellType from '@/components/CellType.vue'

export default {

    mixins: [
        mixinDashboard
    ],

    data() {
        return {
            loading: 0,
            loading: false,
            showModal: false,
            key: null,
            unconfirmModal: false,
            unpublishModal: false
        }
    },

    computed: {
        
        init() {
            if (this.currentUser) return true
            return false
        },
        
        ...mapState({
			currentUser: state => state.user.info,
			currentUserSubordinates: state => state.user.subordinates
		}),

        filteredSubordinates() {
            if (this.currentUserSubordinates) return this.currentUserSubordinates.filter(user => !user.archived)
        },

        users() {
            var users = []
            
            if (this.currentUserSubordinates) {
                users = this.currentUserSubordinates
            }

            return users
        },

        yearSelect() {
            var yearArray = []
            for (var i = this.date.year - 5; i <= this.date.year + 3; i++) {
                yearArray.push(i)
            }
            return yearArray;
        },
    },

    components: {
        SimpleModal,
        Zondicon,
        CellType
    },

    methods: {
        getMarktime(uid) {
            if (this.marktimes) {
                return this.marktimes.find(marktime => marktime.user === uid)
            }
            return false
        },
        
        showMonthName(i) {
            return moment({
                month: i
            }).format('MMMM')
        },

        getUserName(uid) {
			return this.currentUserSubordinates.find(user => user.uid === uid).name
        },

        showConfirmModal(key) {
            this.key = key
            this.showModal = true
        },

        openUnconfirmModal(key) {
            this.key = key
            this.unconfirmModal = true
        },

        openUnpublishModal(key) {
            this.key = key
            this.unpublishModal = true
        },

        getDate(time) {
            if (time) {
                return moment(time.seconds * 1000).format('DD. MM. YYYY HH:mm')
            }
            return ''
        },

        confirm() {

            db
            .collection('marktimes')
            .doc(this.key)
            .update({
                confirmed: true,
                confirmedDate: new Date()
            })
            .then(() => {
                this.showModal = false
                this.$toasted.show(`Confirmed successfully!`, {
                    type: 'success'
                })
            })
            .catch(error => {
                this.showModal = false
                this.$toasted.show(`Error: ${error}`, {
                    type: 'error'
                })
            });
        },

        unconfirm() {

            db
            .collection('marktimes')
            .doc(this.key)
            .update({
                confirmed: false,
                confirmedDate: null
            })
            .then(() => {
                this.unconfirmModal = false
                this.$toasted.show(`Unconfirmed successfully!`, {
                    type: 'success'
                })
            })
            .catch(error => {
                this.unconfirmModal = false
                this.$toasted.show(`Error: ${error}`, {
                    type: 'error'
                })
            });
        },

        unpublish() {

            db
            .collection('marktimes')
            .doc(this.key)
            .update({
                published: false,
                publishedDate: null
            })
            .then(() => {
                this.unpublishModal = false
                this.$toasted.show(`Unpublished successfully!`, {
                    type: 'success'
                })
            })
            .catch(error => {
                this.unpublishModal = false
                this.$toasted.show(`Error: ${error}`, {
                    type: 'error'
                })
            });
        },

        selectDate(add) {

            var time = moment({
                year: this.date.year,
                month: this.date.month
            })
            time.add(add, 'months')
            this.date.month = time.month()
            this.date.year = time.year()

            this.getMarktimes()
        },

        getMarktimes() {

            this.loading = true

            if (!this.currentUser.subordinates) {
                this.loading = false;
                return;
            }

            if (this.currentUser.subordinates.length === 0) {
                this.loading = false;
                return;
            }

            db
            .collection('marktimes')
            .where('user', 'in',  this.currentUser.subordinates)
            //.where('month', '==', this.date.month)
            .where('year', '==', this.date.year)
            .onSnapshot(query => {
                var marktimes = []
                query.forEach(function (doc) {
                    var marktime = doc.data()
                    marktime.id = doc.id
                    marktimes.push(marktime)
                });
                this.allMarktimes = marktimes
                this.loading = false
            })

        },

    },

    created() {

        var interval = setInterval(() => {
            if (this.currentUser) {
                this.getMarktimes()
                if (!this.currentUserSubordinates) this.$store.dispatch('user/getSubordinates')
                clearInterval(interval)
            }
        }, 100)

        this.$store.commit('SET_TITLE', 'My Team MARKTIMES')
    }

}
</script>